import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

interface SnackbarOptions {
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition;
  type?: 'info' | 'success' | 'warn' | 'error';
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  public show(
    notice: string | HttpErrorResponse,
    options?: SnackbarOptions
  ): void {
    const snackbarOptions = { ...options };
    delete snackbarOptions.type;

    let message: string;
    let type = options?.type ?? 'info';

    if (notice instanceof HttpErrorResponse) {
      message = notice.error?.errors?.[0] ?? notice.error;
      type = 'error';
    } else {
      message = notice;
    }
    this.snackBar.open(message, null, {
      duration: 15000,
      panelClass: `opt-snackbar-${type}`,
      ...snackbarOptions,
    });
  }
}
